import { css } from 'emotion';
import { Colors } from 'politico-style';

const { brand } = Colors;

const styles = css`
  border: 1px solid #ccc;
  width: 46px;
  height: 23px;
  border-radius: 12px;
  margin-top: 5px;
  float: right;
  &.on{
    background: #ccc;
    i{
      color: ${brand.politicoRedDark.hex};
      font-size: 14px;
    }
  }

  .switch-toggle{
    width: 21px;
    height: 21px;
  }

  i{
    position: absolute;
    top: 3px;
    left: 8px;
    color: transparent;
  }
`;

export default styles;
